import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../services/contrato'
import Licitante from './licitante';


const ListarLicitantes = () => {
    const [licitantes, setLicitantes] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchLicitantes() {
        const response = await ContratoService.todos();
        if (response.data.length >= 1) {
            const uniqueContratados = [...new Map(response.data.map(item => [item['cnpj'], item])).values()];
            setLicitantes(uniqueContratados)
        } else {
            setLicitantes([])
            setVazio(true)
        }
    }


    useEffect(() => {
        fetchLicitantes();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLicitantes={setLicitantes}
                    setVazio={setVazio}
                    fetchLicitantes={fetchLicitantes}
                    licitantes={licitantes}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={3}>
                        {licitantes.map((licitante, index) =>
                            <Licitante
                                licitante={licitante}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarLicitantes;